// removed by extract-text-webpack-plugin
module.exports = {"image":"image__zzddO"};


//////////////////
// WEBPACK FOOTER
// ./components/common/brand/style.css
// module id = aamf
// module chunks = 323 333 337 339